import { useState, useEffect, useCallback } from 'react'

export default function useApiQuery(fetchFn, deps = [], options = {}) {
  const { enabled = true, initialData = null } = options
  const [data, setData]       = useState(initialData)
  const [loading, setLoading] = useState(enabled)
  const [error, setError]     = useState(null)

  const execute = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const result = await fetchFn()
      setData(result)
      return result
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Something went wrong.'
      setError(message)
      throw err
    } finally {
      setLoading(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  useEffect(() => {
    if (enabled) execute().catch(() => {})
  }, [execute, enabled])

  return { data, loading, error, refetch: execute, setData }
}

export function useApiMutation(mutationFn) {
  const [loading, setLoading] = useState(false)
  const [error, setError]     = useState(null)

  const mutate = useCallback(async (...args) => {
    setLoading(true)
    setError(null)
    try {
      const result = await mutationFn(...args)
      return result
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Something went wrong.'
      setError(message)
      throw err
    } finally {
      setLoading(false)
    }
  }, [mutationFn])

  return { mutate, loading, error }
}
